import { Injectable } from '@angular/core';
import { Overlay } from '@angular/cdk/overlay';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { NewActivityDialogComponent } from './new-activity-dialog.component';

export const NEW_ACTIVITY_DIALOG_ID = 'new-activity-dialog';

@Injectable()
export class NewActivityDialogActionService {

  constructor(
    private overlay: Overlay,
    private dialog: MatDialog
  ) { }

  open(): MatDialogRef<NewActivityDialogComponent, string> | unknown {
    const dialog = this.dialog.getDialogById(NEW_ACTIVITY_DIALOG_ID);
    if (dialog) return dialog.close();
    return this.dialog.open(NewActivityDialogComponent, {
      closeOnNavigation: true,
      autoFocus: 'input',
      id: NEW_ACTIVITY_DIALOG_ID,
      width: '450px',
      minWidth: 0,
      maxWidth: 'auto',
      minHeight: 0,
      maxHeight: '100vh',
      scrollStrategy: this.overlay.scrollStrategies.noop()
    })
  }

  close(): void {
    const dialog = this.dialog.getDialogById(NEW_ACTIVITY_DIALOG_ID);
    if (dialog) return dialog.close();
  }

}
